module.exports = __webpack_public_path__ + "media/St 4-Screen 3.2bf23234.wav";